// import { h1, h2, h3, h4, h5, h6 } from '../styles';

import { SerializedStyles, jsx } from "@emotion/react";
import { ReactNode } from "react";
import { h1, h2, h3, h4, h5, h6 } from "../utils/global-styles";

type HeadingPropsChildren = {
  level: number,
  levelStyle?: number,
  text?: ReactNode,
  children: ReactNode,
  css?: SerializedStyles | SerializedStyles[]
  id?: String
}

type HeadingPropsText = {
  level: number,
  levelStyle?: number,
  text: string,
  children?: string,
  css?: SerializedStyles | SerializedStyles[]
  id?: String
}

type HeadingProps = HeadingPropsChildren | HeadingPropsText;

const Heading:React.FC<HeadingProps> = ({ level, levelStyle, text, children, ...props }) => {

  const styleLevel = levelStyle ?? level;
  const styles = [h1, h2, h3, h4, h5, h6];
  const myStyle = styles[styleLevel - 1];
  const HeadingTag = jsx(`h${level}`, {
    css: myStyle,
    ...props,
  },
  children || text
  );

  return HeadingTag;
};

export default Heading;